import {
  Box,
  VStack,
  HStack,
  Text,
  useDisclosure,
  Flex,
  Badge,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useState } from "react";
import ModalComponent from "../modal";
import { FiUsers, FiUserCheck, FiUserX, FiClock, FiCalendar } from "react-icons/fi";

const NoOfEmployeeTab = ({
  totalEmp,
  absent,
  present,
  lateComers,
  leave,
  data,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [item, setItem] = useState({ name: "", arr: [] });

  const statItems = [
    {
      label: "Total Entries",
      value: present + lateComers,
      icon: <FiUsers size={20} />,
      color: "blue",
      onClick: null,
    },
    {
      label: "Present",
      value: present,
      icon: <FiUserCheck size={20} />,
      color: "green",
      onClick: () => {
        setItem({ name: "Present", arr: data?.totalPresent?.names });
        onOpen();
      },
    },
    {
      label: "Absent",
      value: absent,
      icon: <FiUserX size={20} />,
      color: "red",
      onClick: () => {
        setItem({ name: "Absent", arr: data?.totalAbsent?.names });
        onOpen();
      },
    },
    {
      label: "Late Comers",
      value: lateComers,
      icon: <FiClock size={20} />,
      color: "orange",
      onClick: () => {
        setItem({ name: "Late comers", arr: data?.lateEmployees?.names });
        onOpen();
      },
    },
    {
      label: "On Leave",
      value: leave,
      icon: <FiCalendar size={20} />,
      color: "purple",
      onClick: () => {
        setItem({ name: "On Leave", arr: data?.totalLeave?.names });
        onOpen();
      },
    },
  ];

  return (
    <>
      <VStack spacing={4} align="stretch">
        {statItems.map((stat, index) => (
          <StatItem
            key={index}
            label={stat.label}
            value={stat.value}
            icon={stat.icon}
            color={stat.color}
            onClick={stat.onClick}
          />
        ))}
      </VStack>

      <ModalComponent
        isOpen={isOpen}
        onClose={() => false}
        size="md"
        title={item?.name}
        closeBtn={true}
        closeModal={onClose}
      >
        <VStack spacing={3} maxH="500px" overflowY="auto">
          {!item?.arr?.length ? (
            <Text color="gray.500" textAlign="center" py={8}>
              No record for {item?.name?.toLowerCase()} employee
            </Text>
          ) : (
            item?.arr?.map((name, index) => (
              <Box
                key={index}
                w="100%"
                p={3}
                bg="gray.50"
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.200"
              >
                <Text textAlign="center" fontWeight="500" color="gray.700">
                  {name}
                </Text>
              </Box>
            ))
          )}
        </VStack>
      </ModalComponent>
    </>
  );
};

const StatItem = ({ label, value, icon, color, onClick }) => {
  const colorScheme = {
    blue: { bg: "blue.50", color: "blue.600", iconBg: "blue.100" },
    green: { bg: "green.50", color: "green.600", iconBg: "green.100" },
    red: { bg: "red.50", color: "red.600", iconBg: "red.100" },
    orange: { bg: "orange.50", color: "orange.600", iconBg: "orange.100" },
    purple: { bg: "purple.50", color: "purple.600", iconBg: "purple.100" },
  };

  const colors = colorScheme[color] || colorScheme.blue;

  return (
    <Box
      bg="gray.50"
      p={4}
      borderRadius="12px"
      border="1px solid"
      borderColor="gray.200"
      cursor={onClick ? "pointer" : "default"}
      _hover={
        onClick
          ? {
              bg: "gray.100",
              transform: "translateY(-1px)",
              shadow: "sm",
            }
          : {}
      }
      transition="all 0.2s"
      onClick={onClick}
    >
      <HStack spacing={4} align="center">
        <Box
          p={2}
          borderRadius="8px"
          bg={colors.iconBg}
          color={colors.color}
        >
          {icon}
        </Box>
        <VStack spacing={1} align="start" flex={1}>
          <Text fontSize="sm" color="gray.600" fontWeight="500">
            {label}
          </Text>
          <Text fontSize="lg" fontWeight="700" color="gray.900">
            {value}
          </Text>
        </VStack>
        {onClick && (
          <Badge
            colorScheme={color}
            variant="subtle"
            fontSize="xs"
            px={2}
            py={1}
          >
            View
          </Badge>
        )}
      </HStack>
    </Box>
  );
};

export default NoOfEmployeeTab;
